import type {
	StylableHorizontalMenuDefinition,
	StylableHorizontalMenuPropsCarmiData,
} from '@wix/thunderbolt-components-native'
import type { MenuItemProps } from '@wix/thunderbolt-becky-types'

import { withCompInfo } from '@wix/editor-elements-integrations'

export const props = withCompInfo<StylableHorizontalMenuPropsCarmiData, StylableHorizontalMenuDefinition>()(
	// @ts-expect-error
	['compData', 'hasResponsiveLayout', 'containerRootClassName'],
	// @ts-expect-error
	({ compData, hasResponsiveLayout, containerRootClassName }) => {
		return {
			items: (compData.menuRef as unknown) as Array<MenuItemProps>,
			containerRootClassName: hasResponsiveLayout ? containerRootClassName : '',
		}
	}
)
